export default __webpack_public_path__ + "static/media/doctor.3b24ddee.svg";